export default __webpack_public_path__ + "static/logo-pequenin-desktop-2e45ea768079de6acb7c5e0a77f4a2aa.png";